<header class="site-header">
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="left-logos">
      <a class="navbar-brand " routerLink="/cp-member/home"><img src="assets/images/indusindHeaderLogo.png" fetchpriority
          alt="" /></a>
      <div class="corp-name-logo">
        <div *ngIf="userRole === 'CPHR' || userRole === 'CPMember'">
          <img class="corporate-img" src="{{ corporate.logoImage }}" />
        </div>
        <div *ngIf="userRole === 'CPHR' || userRole === 'CPMember'" class="corporate-name">
          {{ corporate.name }}
        </div>

        <div class="dropdown card-header-dropdown" *ngIf="userRole === 'Broker' || userRole === 'SM'">
          <button class="btn btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            {{ corporate.name }} - {{ corporate.code }}
          </button>
          <div class="dropdown-menu dropdown-sm">
            <div *ngFor="let cor of corporates" (click)="changeCorporate(cor)">
              <a class="dropdown-item">
                <span> {{ cor.name }} - {{ cor.code }} </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="right-user-details">
      <div class="details">
        <div class="profile-img">
          <img *ngIf="user?.sex?.toUpperCase() === 'M'" src="../../../../assets/images/adult-male-profile-pic.png" alt="" />
          <img *ngIf="user?.sex?.toUpperCase() === 'F'" src="../../../../assets/images/Spouse.png" alt="" />
        </div>
        <div class="name" (click)="redirectToManageProfile()">
          <div>Welcome Back!</div>

          <div class="shimmer wrapper" *ngIf="name === undefined">
            <span class="shimmer circle"></span>
            <span class="shimmer circle"></span>
          </div>
          <div *ngIf="name !== undefined">{{name}}</div>
        </div>
        <div class="notifications">

          <!-- Bell Button -->
          <button class="icon-button" cdkOverlayOrigin #origin="cdkOverlayOrigin" (click)="isOpen = !isOpen">
            <img src="../../../../assets/images/bellIcon.png" alt="">
            <span class="badge" *ngIf="unseenNotificationCount >= 0">
              {{ unseenNotificationCount }}
            </span>
          </button>
        
          <!-- DROPDOWN PANEL -->
          
          <ng-template  
          cdkConnectedOverlay
               [cdkConnectedOverlayOpen]="isOpen"
               [cdkConnectedOverlayHasBackdrop]="true"
               (backdropClick)="isOpen = false"
               [cdkConnectedOverlayOrigin]="origin"
               (detach)="isOpen = false"        
          >        
            <div class="notif-panel">
        
              <div class="panel-header">
                <div class="title">Notifications</div>
                <button class="mark-read" (click)="markAllRead()" 
                        [disabled]="unseenNotificationCount === 0">
                  Mark all as read
                </button>
              </div>
        
              <!-- EMPTY STATE -->
              <ng-container *ngIf="notifications.length === 0; else notifList">
                <div class="empty-state">
                  <div class="empty-emoji">🔕</div>
                  <div class="empty-title">No notifications</div>
                  <div class="empty-desc">
                    You’re all caught up. We’ll let you know when something new arrives.
                  </div>
                </div>
              </ng-container>
        
              <!-- LIST STATE -->
              <ng-template #notifList>
                <div class="notif-item" *ngFor="let n of notifications">
                  <div class="notif-item__header">
                    <span class="chip">{{ n.category }}</span>
                    <span class="time">{{ n.timeAgo }}</span>
                  </div>
        
                  <div class="notif-item__title">{{ n.title }}</div>
                  <div class="notif-item__desc">{{ n.description }}</div>
        
                  <div class="doc-card" *ngIf="n.attachment">
                    <div class="doc-left">
                      <span class="doc-name">{{ n.attachment.name }}</span>
                    </div>
                    <div class="doc-actions">
                      <button class="icon" (click)="download(n)">⬇️</button>
                      <button class="icon" (click)="share(n)">🔗</button>
                    </div>
                  </div>
                </div>
              </ng-template>
        
              <button class="view-all" (click)="viewAll()">View all</button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- <div class="shimmer wrapper" *ngIf="name === undefined">
      <span class="shimmer circle"></span>
      <span class="shimmer circle"></span>
    </div>
    <div *ngIf="name === undefined || name === ''" class="shimmer lighter circle ml-2"></div>

    <div class="user-menu" *ngIf="name !== undefined && name !== ''">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link">
            <span>{{ name }}</span>
            <figure *ngIf="corporate.logoImage; else demoLogoImage">
              <img src="{{ corporate.logoImage }}" alt="" height="35" width="35" />
            </figure>
            <ng-template #demoLogoImage>
              <figure>
                <img src="../../../../assets/images/default_company.png" alt="" height="35" width="35" />
              </figure>
            </ng-template>

            <div hidden class="shimmer lighter circle ml-2"></div>
          </a>
        </li>
      </ul>
    </div> -->
  </nav>
</header>